function f(n) {
  var r = !1, o = n.length, t = [];
  return n.length ? new Promise(function(i, c) {
    n.forEach(function(u, a) {
      u.catch(function(e) {
        return r = !0, e;
      }).then(function(e) {
        o -= 1, t[a] = e, !(o > 0) && (r && c(t), i(t));
      });
    });
  }) : Promise.resolve([]);
}
export {
  f as allPromiseFinish
};
//# sourceMappingURL=asyncUtil.mjs.map
